import api from 'api';

export const login = ({ data }) => api().post('/login', data);
export const updatePassword = ({ id, data }) => api().post(`/reset_password/${id}`, data);
export const logout = () => api().delete('logout');
export const recovery = ({ data: { email } }) => api().get(`request_reset_password/${email}`);
export const getLoggedUser = () => api().get('/user');
